import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: process.env.REACT_APP_VERSION,

  // Route events through our own Cloudflare Worker so ad blockers / privacy
  // extensions don't drop requests to *.ingest.sentry.io. See workers/sentry-proxy/.
  tunnel: 'https://sentry-proxy.hippo.co.za',

  // Capture full PII (IP address, request headers/cookies, user context) —
  // no client-side anonymisation.
  sendDefaultPii: true,

  integrations: [
    // React Router v7 in declarative mode (<BrowserRouter> + <Routes>)
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      // Don't pull a session replay for API/backend failures. Those are still
      // sent to Sentry for alerting (see apiServices.js), but they're tagged
      // with `api_endpoint`, so we skip replay sampling for them here. Return
      // false = ignore this error for replay; true = let replaysOnErrorSampleRate
      // decide. Result: replays only accompany real errors thrown to the screen.
      beforeErrorSampling: (event) => !event.tags?.api_endpoint,
    }),
  ],

  // Tracing
  tracesSampleRate: 0.1, // capture a performance transaction for 10% of sessions
  tracePropagationTargets: ['localhost', /^https:\/\/api\.hippo\.co\.za/],

  // Session Replay — only ever capture a replay when a real error is thrown to
  // the screen; never record ordinary (non-error) sessions.
  replaysSessionSampleRate: 0, // no always-on / random session replays
  replaysOnErrorSampleRate: 1.0, // capture the session on every real error
});
